import loadable from '@loadable/component';
import { Loader } from 'components';

export const AsyncFinance = loadable(
  () => import('pages/Registration/Finance/Finance'),
  {
    fallback: <Loader />,
  },
);
